var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "jhi-navbar-root" },
    [
      _c(
        "b-navbar",
        { attrs: { toggleable: "xl", type: "dark", sticky: "" } },
        [
          _c(
            "b-navbar-brand",
            { attrs: { href: "https://conahcyt.mx/", target: "_blank" } },
            [
              _c("img", {
                staticClass: "conahcyt",
                attrs: {
                  src: require("../../../content/images/logo_blanco.svg"),
                  alt: "Conahcyt",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "logo-rizoma" }, [
            _c("img", {
              attrs: {
                src: require("../../../content/images/logo-rizoma-blanco.svg"),
                alt: "Logo Rizoma",
              },
            }),
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
          _vm._v(" "),
          _c("b-collapse", { attrs: { id: "nav-collapse", "is-nav": "" } }, [
            _c(
              "div",
              { staticClass: "nav-collapse-2" },
              [
                _c(
                  "b-navbar-nav",
                  [
                    _c(
                      "b-nav-item",
                      { attrs: { href: "https://secihti.mx/" } },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.$t("global.menu.home")),
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-navbar-nav",
                  { staticClass: "navbar-right" },
                  [
                    _c(
                      "b-nav-item",
                      {
                        attrs: {
                          href: "https://secihti.mx/centro-de-contacto-de-atencion/",
                        },
                      },
                      [
                        _c("span", { staticClass: "icon-ayuda" }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.$t("global.menu.contacto")),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("b-nav-item", { on: { click: _vm.showDownloadModal } }, [
                      _c("span", { staticClass: "icon-descargar" }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("perfil-unico.title-descarga-manual")
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-nav-item-dropdown",
                      {
                        staticClass: "pointer",
                        class: {
                          "router-link-active": _vm.subIsActive("/account"),
                        },
                        attrs: {
                          right: "",
                          id: "account-menu",
                          "active-class": "active",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "navbar-dropdown-menu",
                            attrs: { slot: "button-content" },
                            slot: "button-content",
                          },
                          [
                            _c("span", { staticClass: "icon-usuario" }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "no-bold",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.main")
                                ),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.authenticated
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  "data-cy": "logout",
                                  id: "logout",
                                  "active-class": "active",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.logout()
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "sign-out-alt" },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.account.logout")
                                    ),
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.authenticated
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  "data-cy": "login",
                                  id: "login",
                                  "active-class": "active",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openLogin()
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "sign-in-alt" },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.account.login")
                                    ),
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "download-modal",
            title: _vm.$t("perfil-unico.select-manual-title"),
            centered: "",
            size: "lg",
            "body-class": "p-4",
          },
          on: { hide: _vm.resetSelection },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "w-100",
                          attrs: { variant: "primary" },
                          on: { click: _vm.resetSelection },
                        },
                        [
                          _c("b-icon", {
                            staticClass: "me-2",
                            attrs: { icon: "x-circle" },
                          }),
                          _vm._v("\n          Cerrar\n        "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            [
              _c(
                "b-list-group",
                { attrs: { flush: "" } },
                _vm._l(_vm.manuals, function (manual) {
                  return _c(
                    "b-list-group-item",
                    {
                      key: manual.id,
                      attrs: { button: "" },
                      on: {
                        click: function ($event) {
                          return _vm.downloadManual(manual.link)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between w-100",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center gap-3" },
                            [
                              _c("b-icon", {
                                staticClass: "text-danger mr-3",
                                attrs: {
                                  icon: "file-earmark-pdf",
                                  "font-scale": "1.5",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "fw-500" }, [
                                _vm._v(_vm._s(_vm.$t(manual.titleKey))),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-icon", {
                            staticClass: "text-primary",
                            attrs: { icon: "download", "font-scale": "1.25" },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }